import { useState, useEffect } from 'preact/hooks'

/**
 *
 *
 *
 * @param {*} inputs
 *
 * inputs : {
 *  [key: string] : any
 * }
 *
 * @returns
 */
export const useFormInput = (inputs) => {
  const [formInputs, setFormInputs] = useState(() => {
    const keys = Object.keys(inputs)
    return keys.reduce((acc, key) => {
      acc[key] = {
        key,
        value: inputs[key]
      }
      return acc
    }, {})
  })
  const [initialInputs, setInitialInputs] = useState(inputs)
  const [hasChanged, setHasChanged] = useState(false)

  useEffect(() => {
    const keys = Object.keys(formInputs)
    const changed = keys.some(key => {
      // Ensure initialInputs has the key before comparing
      // This handles cases where formInputs might have keys not initially present, though less common with current setup
      if (Object.prototype.hasOwnProperty.call(initialInputs, key)) {
        return formInputs[key].value !== initialInputs[key]
      }
      // If a key exists in formInputs but not in initialInputs, consider it a change if it has a value
      // Or, if the hook is designed to only track changes from the initial set, this could be `return false`
      return formInputs[key].value !== undefined && formInputs[key].value !== '' // Example: consider new fields with values as changes
    })
    setHasChanged(changed)
  }, [formInputs, initialInputs])

  const handleEventOnType = (input, customType) => {
    if (input.type === 'checkbox' && (customType === 'default' || customType === 'checkbox')) {
      return {
        name: input.name,
        value: input.checked
      }
    }
    return {
      name: input.name,
      value: input.value
    }
  }

  const setDefaults = (defaults) => {
    const keys = Object.keys(defaults)
    const data = keys.reduce((acc, key) => {
      acc[key] = {
        key,
        value: inputs[key]
      }
      return acc
    }, {})
    setFormInputs(() => ({ ...data }))
  }

  /**
   * @param {JSXInternal.TargetedEvent<HTMLInputElement, Event>} event
   */
  const handleOnChange = (event) => {
    const input = event.currentTarget
    const customType = input?.dataset?.customType ?? 'default'
    const { name, value } = handleEventOnType(input, customType)
    setFormInputs((i) => ({
      ...i,
      [name]: {
        ...i[name],
        value
      }
    }))
  }

  return { formInputs, handleOnChange, setDefaults, hasChanged }
}
